import React from "react"
import { setHeader } from "@/util/set-header";
import { Button, ImagePicker, Carousel, Toast, ActionSheet, TextareaItem } from "antd-mobile";
import './lineup-info.less'
import { withRouter } from "react-router";
import Cookies from "universal-cookie";
import compress from '@/util/image-compress'
import { phonePlatform } from "@/util/util";
import { lineupRommInfoApi, employeeInfoApi, uploadImageApi, submitLineupApi} from "@/api/sany";

const cookie = new Cookies()
@(withRouter as any)
export default class LineupInfo extends React.Component<any, any> {
  detailInfo: any = {}
  // imgArr = []
  userInfo: any = {}
  

  constructor(props: any) {
    super(props)
    this.state = {
      tab: 1,
      payType: 1, //工资划扣1，部门划转2
      department:'请选择部门级别',
      departmentId:'',
      apply_reason:'',
      departmentList: [],
      imgArr: [],
      files: [],
      imgHeight: 277.5,
    }
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.uploadImg = this.uploadImg.bind(this)
    this.payType = this.payType.bind(this)
    this.showTip = this.showTip.bind(this)
    this.hideTip = this.hideTip.bind(this)
    this.onAddImageClick = this.onAddImageClick.bind(this)
    this.selectedFile = this.selectedFile.bind(this)
    this.onChangeUploadImg = this.onChangeUploadImg.bind(this)
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge?.navBackMarket?.call(window.WebViewBridge)
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('');
      }
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  componentDidMount() {
    setHeader({ title: '预约排队', leftToHome: this.goHomePage, leftClick: this.leftClick })
    // const obj:any = (sessionStorage.getItem('roomInfo'))
    // this.detailInfo = JSON.parse(obj)
    this.getUserInfo()
    this.fetchRoomInfo()
    // if(this.detailInfo&&this.detailInfo.image) {
    //   this.imgArr = this.detailInfo.image
    // }
  }

  async getUserInfo(){
    const {data} = await employeeInfoApi({phone:cookie.get('sany_phone'), room_type:this.props.location.state&&this.props.location.state.roomId})
    // const {data} = await employeeInfoApi({phone:15868194226, room_type:this.props.location.state&&this.props.location.state.roomId})
    if (data.code === 'SUCCESS') {
      this.userInfo = data.data
    } else {
      Toast.info(data.msg)
    }
  }

  async fetchRoomInfo() {
    const storeID = this.props.location.state.storeId
    const roomID = this.props.location.state.roomId
    Toast.loading('加载中...')
    const {data} = await lineupRommInfoApi({ store_id: storeID, room_type: roomID })
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.detailInfo = data.data
      if(this.detailInfo&&this.detailInfo.image) {
        this.setState({
          imgArr: this.detailInfo.image
        })
      }
    } else if (data.msg) {
      Toast.info(data.msg)
    } else {
      Toast.info('接口请求错误，请重新打开页面~')
    }
  }

  selectedFile(event: any) {
    // if(this.state.files.length > 3) {
    //   Toast.info('最多只能上传4张图片')
    //   return
    // }
    let file = event.target.files[0]
    event.target.value = ''
    //图片压缩
    compress(
      file,
      {
        compress: {
          width: 1000,
          height: 1000,
          quality: 0.8,
        },
        type: 'file',
      },
      async (resizeFile: any) => {
        // compressCallBack(resizeFile)
        let size = Math.round((resizeFile.size * 100) / (1024 * 1024)) / 100 //按MB换算
        console.log('size', size)
        //限制大小小于2M
        if (size < 2) {
          let formData = new FormData()
          formData.append('image', resizeFile)
          formData.append('type', 'user_face')
          Toast.info('图片上传中')
          const { data } = await uploadImageApi(formData)
          Toast.hide()
          if (data.code === 'SUCCESS') {
              let arr:any = this.state.files
              arr.push({url:data.data.url,id:'1'})
              this.setState({
                files:arr,
              });
          } else {
            Toast.info(data.msg)
          }
        } else {
          Toast.info('文件大小超过系统规定大小')
        }
      },
    )
  }
  // 上传图片
  async onChangeUploadImg(files: any, type: any, index: any) {
    if (type==='remove') {
      this.setState({
        files,
      })
    } else {
      //图片压缩
      compress(
        files[files.length - 1].file,
        {
          compress: {
            width: 1600,
            height: 1600,
            quality: 0.5,
          },
          type: 'file',
        },
        async (resizeFile: any) => {
          let size = Math.round((resizeFile.size * 100) / (1024 * 1024)) / 100 //按MB换算
          //限制大小小于2M
          if (size < 2) {
            let formData = new FormData()
            formData.append('image', files[files.length-1].file)
            formData.append('type', 'user_face')
            Toast.info('图片上传中')
            const { data } = await uploadImageApi(formData)
            Toast.hide()
            if (data.code === 'SUCCESS') {
                let arr:any = this.state.files
                arr.push({url:data.data.url,id:'1'})
                this.setState({
                  files:arr,
                });
            } else {
              Toast.info(data.msg)
            }
          } else {
            Toast.info('文件大小超过系统规定大小')
          }
        },
      )
    }
  }

  // 房间图片
  roomImg() {
    const imgW = window.screen.width - 20
    // const imgH = (imgW * 3 / 4) + 'px'
    if(this.state.imgArr&&this.state.imgArr.length > 0) {
      const arr:any = []
      this.state.imgArr.forEach((v:any)=>{
        arr.push(v.url)
      })
      return (
        <div className="component-body">
          <div className="dorm-info">
            {/* <WingBlank> */}
                <Carousel
                  autoplay
                  infinite
                >
                  {arr.map((val:any) => (
                    <a
                      key={val}
                      style={{ display: 'inline-block', width: '100%', height: '100%' }}
                    >
                      <img
                        src={val}
                        alt=""
                        style={{ width: '100%', height:'100%', verticalAlign: 'top',borderRadius: '5px', objectFit: 'cover' }}
                        onLoad={() => {
                          // fire window resize event to change height
                          window.dispatchEvent(new Event('resize'));
                          // this.setState({ imgHeight: 'auto' });
                        }}
                      />
                    </a>
                  ))}
                </Carousel>
              {/* </WingBlank>  */}
            <div className="between-row dorm-info-mid">
              <div>
                <span style={{ fontSize: '16px' }}>{this.detailInfo.name}</span>
                <span style={{ fontSize: '14px', color: '#888888', marginLeft:'15px' }}>{this.detailInfo.acreage}{this.detailInfo.acreage?'m²':''}</span>
              </div>
              <div>
                {/* <span style={{ fontSize: '14px', color:'#cf6568' }}>{this.detailInfo.property === '3' ? this.detailInfo.month_price : this.detailInfo.day_price}{this.detailInfo.property === '3' ?'元/床/月':'元/天'}</span> */}
                <span style={{ fontSize: '14px', color: '#cf6568' }}>{this.detailInfo.month_price}{this.detailInfo.month_price?'元/床/月':''}</span>
              </div>
            </div>
            <div className="dorm-info-mid" style= {{ borderTop: '1px solid #eeeeee'}} >
              <div style={{ fontSize: '14px', color: '#888888' }}>房间简介：</div>
              <div style={{ fontSize: '14px', color: '#888888', marginTop:'5px' }}>{this.detailInfo.short_desc}</div>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="component-body">
          <div className="dorm-info">
            <div>
              {/* <img src="//s1.axhome.com.cn/homepage/b3/e5/b3e5bb3c6fc92e9038c3e5a84f167615.jpg" alt="" style={{ width: '100%', height: '100%' }} /> */}
              <img src="/public/assets/img/picture.png" alt="" style={{ width: '100%', height: this.state.imgHeight }} />
            </div>
            <div className="between-row dorm-info-mid">
              <div>
                <span style={{ fontSize: '16px' }}>{this.detailInfo.name}</span>
                <span style={{ fontSize: '14px', color: '#888888', marginLeft:'15px' }}>{this.detailInfo.acreage}{this.detailInfo.acreage?'m²':''}</span>
              </div>
              <div>
                {/* <span style={{ fontSize: '14px', color:'#cf6568' }}>{this.detailInfo.property === '3' ? this.detailInfo.month_price : this.detailInfo.day_price}{this.detailInfo.property === '3' ?'元/床/月':'元/天'}</span> */}
                <span style={{ fontSize: '14px', color: '#cf6568' }}>{this.detailInfo.month_price}{this.detailInfo.month_price?'元/床/月':''}</span>
              </div>
            </div>
            <div className="dorm-info-mid" style= {{ borderTop: '1px solid #eeeeee'}} >
              <div style={{ fontSize: '14px', color: '#888888' }}>房间简介：</div>
              <div style={{ fontSize: '14px', color: '#888888', marginTop:'5px' }}>{this.detailInfo.short_desc}</div>
            </div>
          </div>
        </div>
      )
    }
  }
  textAreaChange(v: any) {
    this.setState({
      apply_reason: v
    })
  }
  onAddImageClick(e:any) {
    if(this.state.files.length === 0) {
      this.setState({
        files: []
      })
    }
  }
  onImageClick(index: any, files: any) {
    console.log(index,'index')
    console.log(files,'files')
  }
 // 上传图片
 uploadImg() {
  const { files } = this.state;
  return (
    <div className="dorm-info-mid">
      <div style={{border: '1px solid #ccc',borderRadius:'3px'}}>
        <TextareaItem
          onChange={e => this.textAreaChange(e)}
          className="text-area"
          placeholder="请描述原因..."
          rows={3}
          count={150}
        />
          <ImagePicker
            files={files}
            onChange={this.onChangeUploadImg}
            onAddImageClick= {this.onAddImageClick}
            onImageClick={(index, fs) => console.log(index, fs)}
            selectable={files.length < 3}
          />
      </div>
    <p style={{ color: 'red', fontSize: '14px',marginTop:'10px' }}>您预订的房间级别超过公司规定/选择部门划转,需部门负责人审批通过后方可办理入住</p>
  </div>
  )
}
  // 提交预约按钮
  submitButton() {
    return (
      <Button className="submit-btn" onClick={() => this.submitClick()}>提交排队</Button>
    )
  }

  async submitClick() {
    if (this.userInfo.phone === undefined) {
      Toast.info('员工手机号不合法~')
      return
    }
    const storeId = this.props.location.state.storeId
    // const tab = this.props.location.state.tab
    const roomId = this.props.location.state.roomId
    const img:any = []
    this.state.files.forEach((v:any) => {
      img.push(v.url)
    })
    const params = {
      store_id: storeId,
      phone: this.userInfo.phone,
      apply_reason: this.state.apply_reason,//申请原因
      // tab: tab,
      img: JSON.stringify(img),
      pay_type: this.state.payType, //付费方式 1： 工资划扣 2： 部门划转
      pay_type_department: this.state.departmentId || '', //如果选择2 则传划扣的部门id
      room_type: roomId,
      room_property: '3'
    }
    Toast.loading('请求中')
    const {data} = await submitLineupApi(params)
    Toast.hide()
    if (data.code === 'SUCCESS') {
      this.props.history.push({ pathname: '/sany/lineup-detail', query: { id: data.data.id }})
    } else if (data.msg) {
      Toast.info(data.msg)
    } else {
      Toast.info('接口请求失败，请重试~')
    }
  }
  // 选择工资划扣
  hideTip() {
    this.setState({
      tab: 1,
      payType: 1,
      apply_reason: '',
      pay_type_department: '',
      img: [],
    },() => {
      sessionStorage.setItem('roomInfo', JSON.stringify({tab:'1'}))
    })
  }
  // 选择部门划转
  showTip() {
    this.setState({
      tab: 2,
      payType: 2
    },async ()=> {
      sessionStorage.setItem('roomInfo', JSON.stringify({tab:'2'}))
      const {data} = await employeeInfoApi({phone:cookie.get('sany_phone'),room_type:this.props.location.state&&this.props.location.state.roomId})
      // const {data} = await employeeInfoApi({phone:15868194226,room_type:this.props.location.state&&this.props.location.state.roomId})
      const res = (data)
      if (res.code === 'SUCCESS') {
        (this as any).state.departmentList = res.data.department
      }
    })
  }
   // 是否显示部门
   department(){
    return(
      <div className="dorm-info-mid">
        <div className="between-row" style={{ height: '40px', margin:'10px 0' }}>
          <span style={{ color: '#434343', fontSize: '16px' }}>选择部门级别</span>
          <span onClick={() => this.changeDepartment()} style={{ color: '#868686', fontSize: '14px' }}>{this.state.department + " >"}</span>
        </div>
      </div>
    )
  }
  // 获取部门
  async changeDepartment() {
    // const {data} = await employeeInfoApi({phone:'15221511724'})
    // const res = JSON.parse(data)
    let BUTTONS:any = []
    BUTTONS = this.state.departmentList
    const optionArr:any = []
    BUTTONS.forEach((v:any)=> {
      optionArr.push(v.name)
    })
    ActionSheet.showActionSheetWithOptions({
        options: optionArr,
        message: '请选择',
        maskClosable: true
      },
      (buttonIndex: number) => {
        if (buttonIndex >= 0 && buttonIndex < BUTTONS.length) {
          this.setState({
            department: BUTTONS[buttonIndex].name,
            departmentId: BUTTONS[buttonIndex].id,
          })
        }
      });
  }
  // 付费方式
  payType() {
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-title">
            <span style={{ color: '#333333', fontSize: '14px' }}>前方正有<span style={{color: '#169bd5', fontSize: '14px'}}>{this.detailInfo.queue_count}</span>人在等待该房型</span>
          </div>
          <div className="dorm-info-title">
            <span style={{ color: '#333333', fontSize: '16px' }}>请选择扣费方式</span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{ height: '42px' }}>
              <Button style={{ width: '50%' }} onClick={this.hideTip} className={this.state.tab === 1 ? 'payTypeactive' : 'payTypeTab'}>工资划扣</Button>
              <Button style={{ width: '50%' }} onClick={this.showTip} className={this.state.tab === 2 ? 'payTypeactive' : 'payTypeTab'}>部门划转</Button>
            </div>
            {this.state.payType === 2 ? this.department() : ''}
            {this.state.payType === 2 ? this.uploadImg() : ''}
          </div>
        </div>
      </div>
    )
  }
  render() {
    return (
      // <div className="lineup-info">
      <div className={phonePlatform() === 'iOS' ? 'lineup-info-hei' : 'lineup-info'}>
        {this.roomImg()}
        {/* {this.uploadImg()} */}
        {this.userInfo&&this.userInfo.roomtype&&this.userInfo.roomtype.property === '1' && sessionStorage.getItem('reservationType') === 'changeBed' ? '' : this.payType() }
        {this.submitButton()}
      </div>
    )
  }
}